import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import MasterGamesList from "../data/MasterGamesList"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import { useNavigate } from "react-router-dom"

export default function GatesOfOlympus() {
  const data = promotionsData.find(
    (promo) => promo.title === "Gates of Olympus Roulette"
  )
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Gates Of Olympus Roulette</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions</a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Gates of Olympus Roulette</h1>
                <h2>2,150 Daily Prize up to ₱841,000</h2>
                <div className="promotion-tnc-period">
                  <p>
                    <strong>Event Duration: </strong>
                    <span>April 10 - April 17, 2026</span>
                  </p>
                </div>
                <div className="promotion-tnc-mechanic-content">
                  <strong>Terms and Conditions</strong>
                  <ol>
                    <li>
                      15,050 prizes with a prize pool of ₱5,887,000 will be
                      given out from 10 April 2026 01:00 to 17 April 2026 00:59
                      (GMT+8).
                    </li>
                    <li>
                      Prize drops will run every day from 01:00 to 00:59 (GMT+8)
                      during the promotion period, with 2,150 daily prizes and a
                      daily prize value of ₱841,000.
                    </li>
                    <li>
                      To qualify, players must place a real money bet on{" "}
                      <strong className="highlight">
                        “Gates of Olympus Roulette”
                      </strong>{" "}
                      live casino game.
                    </li>
                    <li>
                      Players will win prizes in the form of a multiplier of the
                      winning player’s bet amount as set out in the prize table.
                    </li>
                    <li>
                      Prize multiplier will be used to determine the final prize
                      amount (bet amount x multiplier won) with a maximum bet
                      limit of ₱58. If the bet exceeds ₱58 any amount over the
                      limit will not be considered in the prize calculation.
                    </li>
                    <li>
                      Each player may win up to 2 prizes in each daily prize
                      drops.
                    </li>
                    <li>
                      Pragmatic Play reserves the right to amend, suspend or
                      cancel the promotion at any time and without prior notice.
                    </li>
                  </ol>
                  <strong>Prize pool</strong>
                  <div className="table-wrapper">
                    <table
                      className="promotion-tnc-table"
                      style={{ minWidth: "0" }}
                    >
                      <thead>
                        <tr>
                          <th>Number of Prizes</th>
                          <th>Prizes</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>10</td>
                          <td>x100 Multiplier</td>
                        </tr>
                        <tr>
                          <td>40</td>
                          <td>x50 Multiplier</td>
                        </tr>
                        <tr>
                          <td>200</td>
                          <td>x10 Multiplier</td>
                        </tr>
                        <tr>
                          <td>1,900</td>
                          <td>x5 Multiplier</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <strong>Featured Game</strong>
                  <MasterGamesList
                    limit={1}
                    livegames="on"
                    customQualifiedGames={[
                      {
                        provider: "Pragmatic",
                        gameName: "Gates of Olympus Roulette",
                      },
                    ]}
                    linkTo={null}
                    headerText={null}
                    subtext={null}
                    headerTag="h2"
                  />
                  <div className="promotion-tnc-cta">
                    <a
                      className="promotion-cta-btn"
                      href="https://ppgames.asia/tl/gates-of-olympus-roulette-daily-prize-drops/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      View Full T&C
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
